<template>
  <div class="all">
    <div class="header-top">
      <span>标准图框</span>
      <div class="leftBox">
        <el-input v-model="searchValue" placeholder="请输入文件名称" size="small" @keyup.enter.native="search"></el-input>
        <el-button v-if="uploadFrame" type="primary" size="small" @click="uploadBtn">上传</el-button>
      </div>
    </div>
    <div class="midd">
      <el-table ref="multipleTable" :data="tableData" border highlight-current-row height="100%">
        <template slot="empty">
          <img :src="zanwu" alt="" />
          <p style="font-size: 16px; color: #000; margin-top: 36px">暂无数据</p>
        </template>
        <el-table-column label="序号" align="center" type="index" width="60" />
        <el-table-column label="文件名称" prop="fileName" min-width="200px">
          <template #default="{ row }">
            <el-link v-if="editFrame" type="primary" @click="changeRemark(row)">
              <span class="tabLinkSpan" :title="row.fileName">{{ row.fileName }}</span>
            </el-link>
            <span v-else class="tabLinkSpan" :title="row.fileName">{{ row.fileName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="E图框名称" prop="eFrameName" min-width="200px" />
        <el-table-column label="分类" prop="classify" align="center" min-width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.classify === 1">联合体图框</span>
            <span v-else>普通图框</span>
          </template>
        </el-table-column>
        <el-table-column label="创建人" align="center" prop="operatorName" min-width="120px" />
        <el-table-column label="上传时间" align="center" prop="uploadTime" min-width="120px" />
        <el-table-column label="最近更新时间" prop="updateTime" min-width="120px" />
        <el-table-column label="备注" prop="remark" min-width="120px" />
        <el-table-column v-if="downFrame||deleFrame||editFrame" label="操作" align="center" min-width="160px">
          <template slot-scope="scope">
            <span v-if="downFrame" class="btn" @click="download(scope.row)">下载</span>
            <span v-if="deleFrame" class="btn" @click="deleteBtn(scope.row)">删除</span>
            <span v-if="editFrame" class="btn" @click="changeRemark(scope.row)">修改</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--修改 -->
    <el-dialog v-dialogDrag :title="framTitle" :visible.sync="editPersonDialog" :before-close="clickClose"
      :close-on-click-modal="false" :close-on-press-escape="false" width="600px">
      <el-form ref="frameForm" :model="frameForm" :rules="rules" label-width="150px" size="small">
        <el-form-item label="图框类型:" prop="frameTypeID">
          <el-select v-model="frameForm.frameTypeID" style="width: 100%" clearable filterable>
            <el-option v-for="item in frameTypeList" :key="item.id" :value="item.id" :label="item.cnName" />
          </el-select>
        </el-form-item>
        <el-form-item label="图框规格:" prop="frameSpecID">
          <el-select v-model="frameForm.frameSpecID" style="width: 100%" clearable filterable>
            <el-option v-for="item in FrameSpecList" :key="item.id" :value="item.id" :label="item.cnName" />
          </el-select>
        </el-form-item>
        <el-form-item label="分类:" prop="classify" :rules="{ required: true, message: '请选择分类' }">
          <el-select v-model="frameForm.classify" style="width: 100%" clearable filterable>
            <el-option label="普通图框" value="0"></el-option>
            <el-option label="联合体图框" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注:" prop="remark" style="line-height: 40px">
          <el-input v-model="frameForm.remark" :autosize="{ minRows: 2, maxRows: 6 }" type="textarea" maxlength="200" />
        </el-form-item>
        <el-form-item v-if="submitType == 0" label="文件:" prop="fileList">
          <el-upload ref="upload" :limit="1" :disabled="upload" :file-list="frameForm.fileList" :auto-upload="false"
            :http-request="httpRequest" :on-change="uploadChange" :on-remove="onRemove" accept=".dwg" class="upload-file"
            style="display: inline-block; margin: 0 10px" action="/">
            <el-button size="small" plain>上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item v-if="submitType == 1" label="文件名称:" prop="fileName">
          <el-input v-model="frameForm.fileName" maxlength="100" />
        </el-form-item>
        <el-form-item label="E图框名称:" prop="eFrameName">
          <el-input v-model="frameForm.eFrameName" maxlength="100" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="clickClose">取 消</el-button>
        <el-button v-if="submitType == 1" type="primary" size="small" @click="sureChangeRemark">确 定</el-button>
        <el-button v-if="submitType == 0" type="primary" size="small" @click="addChangeRemark">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import standardFrame from "@/CommonDP/service/standardDrawingFrame-service";
import { checkPermission, disablePrompt } from "@/CommonDP/utils/routeAuth";
import { mapState } from "vuex";
export default {
  name: "StandardDrawingFrame",
  data() {
    return {
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      tableData: [],
      editPersonDialog: false,
      frameForm: {
        remark: "",
        frameTypeID: "",
        frameTypeName: "",
        frameSpecID: "",
        classify: "0",
        frameSpecName: "",
        fileList: [],
        fileName: "",
        eFrameName: ""
      },
      frameType: [
        {
          value: "通用",
          label: "通用"
        },
        {
          value: "其他",
          label: "其他"
        }
      ],
      submitType: "",
      fileID: undefined,
      upload: false,
      list: [],
      rules: {
        frameTypeID: [{ required: true, message: "请选择图框类型", trigger: "change" }],
        fileList: [{ required: true, message: "请先上传文件", trigger: "blur" }],
        frameSpecID: [{ required: true, message: "请选择图框规格", trigger: "change" }]
      },
      refreshFrame: checkPermission(this.$allPerms.STANDARDDRAWINGFRAME_REFRESH),
      deleFrame: checkPermission(this.$allPerms.STANDARDDRAWINGFRAME_DALE),
      renameFrame: checkPermission(this.$allPerms.STANDARDDRAWINGFRAME_RENAME),
      uploadFrame: checkPermission(this.$allPerms.STANDARDDRAWINGFRAME_UPLOAD),
      downFrame: checkPermission(this.$allPerms.STANDARDDRAWINGFRAME_DOWN),
      editFrame: checkPermission(this.$allPerms.STANDARDDRAWINGFRAME_EDIT),
      frameTypeList: [],
      FrameSpecList: [],
      // fileList: [],
      searchValue: '',
      searchList: []
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    framTitle() {
      return ["上传", "修改"][this.submitType];
    }
  },
  watch: {
    "frameForm.frameTypeID"(newValue) {
      const find = this.frameTypeList.find(({ id }) => id === newValue);
      this.frameForm.frameTypeName = find ? find.cnName : "";
    },
    "frameForm.frameSpecID"(newValue) {
      const find = this.FrameSpecList.find(({ id }) => id === newValue);
      this.frameForm.frameSpecName = find ? find.cnName : "";
    },
    searchValue(newValue) {
      if (!newValue) {
        this.getList();
      }
    }
  },
  mounted() {
    this.getList();
    this.getTypeList();
    this.getSpecList();
  },
  methods: {
    // 获取图框类型字典
    async getTypeList() {
      const res = await standardFrame.getDicContentList("FrameType");
      this.frameTypeList = res.data;
    },
    // 获取图框规格字典
    async getSpecList() {
      const res = await standardFrame.getDicContentList("FrameSpec");
      this.FrameSpecList = res.data;
    },

    uploadChange(file, fileList) {
      this.frameForm.fileList = fileList;
      this.$refs.frameForm.validateField("fileList");
    },
    onRemove(file, fileList) {
      this.frameForm.fileList = [];
      this.$refs.frameForm.validateField("fileList");
    },
    // 上传
    uploadBtn() {
      const a = disablePrompt();
      if (a) {
        this.editPersonDialog = true;
        this.submitType = 0;
      }
    },
    async httpRequest({ file }) {
      const data = new FormData();
      const { remark, frameTypeID, frameTypeName, frameSpecID, frameSpecName, fileName, classify, eFrameName } = this.frameForm;
      data.append("filedwg", file);
      data.append("frameTypeID", frameTypeID);
      data.append("frameTypeName", frameTypeName);
      data.append("frameSpecID", frameSpecID);
      data.append("frameSpecName", frameSpecName);
      data.append("remark", remark);
      data.append("fileName", fileName);
      data.append("eFrameName", eFrameName);
      data.append("enterpriseId", this.enterpriseId);
      data.append("classify", classify);
      const res = await standardFrame.uploadStandardFrameFile(data);
      if (res.result === "0") this.$message.success("上传成功");
      this.clickClose();
      this.getList();
    },
    // 列表
    getList() {
      this.tableData = [];
      this.searchList = [];
      standardFrame.selectStandardFrameMaintenance(this.enterpriseId).then(({ data }) => {
        this.tableData = data || [];
        this.searchList = data || [];
      });
    },
    // 删除
    async deleteBtn(row) {
      const a = disablePrompt();
      if (a) {
        await this.$confirm(`此操作将删除${row.fileName}文件，是否继续？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        });
        const res = await standardFrame.deleteStandardFrameFile({
          id: row.fileId
        });
        if (res.result === "0") {
          this.$message({ message: "删除成功", type: "success" });
        }
        this.getList();
      }
    },
    // 下载
    async download(row) {
      const a = disablePrompt();
      if (a) {
        standardFrame.downloadStandardFrameFile(row.fileId).then((response) => {
          if (response.type === "application/json") {
            const fileReader = new FileReader();
            fileReader.onloadend = () => {
              const jsonData = JSON.parse(fileReader.result);
              // 后台信息
              this.$message({ message: jsonData.message, type: "error" });
            };
            fileReader.readAsText(response); // 或者读取response.data
          } else {
            const link = document.createElement("a");
            const blob = new Blob([response], {
              type: "application/octet-stream"
            });
            link.style.display = "none";
            link.href = URL.createObjectURL(blob);
            link.setAttribute("download", decodeURI(row.fileName));
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        });
      }
    },
    // 修改
    async changeRemark({ fileId }) {
      const a = disablePrompt();
      if (a) {
        this.editPersonDialog = true;
        this.submitType = 1;

        standardFrame.getStandardFrameDetails({ fileId }).then((response) => {
          const { fileId, remark, frameTypeID, frameTypeName, frameSpecID, frameSpecName, fileName, classify, eFrameName } = response.data;
          this.frameForm = {
            fileID: fileId,
            remark,
            frameTypeID,
            frameTypeName,
            frameSpecID,
            frameSpecName,
            fileName,
            eFrameName,
            classify: classify + ""
          };
        });
      }
    },

    async addChangeRemark() {
      // if (!this.frameForm.fileList.length) {
      //   this.$message.warning("请先上传文件");
      //   return;
      // }
      await this.$refs.frameForm.validate();
      this.$refs.upload.submit();
    },
    // 修改保存
    async sureChangeRemark() {
      const { enterpriseId } = this;
      await this.$refs.frameForm.validate();
      const params = {
        ...this.frameForm,
        enterpriseId
      };
      const res = await standardFrame.updateStandardFrame(params);
      if (res.result === "0") this.$message.success("修改成功");
      this.clickClose();
    },
    clickClose() {
      this.$refs.frameForm.resetFields();
      this.frameForm.fileList = [];

      this.getList();
      this.$nextTick(() => {
        this.editPersonDialog = false;
      });
    },
    search() {
      const { searchValue: name } = this;
      if (!name) {
        return this.$message.warning("请输入文件名称");
      }
      setTimeout(() => {
        this.tableData = this.searchList.filter((item) => this.filterKeyword(item, name));
      }, 500);
    },
    filterKeyword(item, name) {
      const keyArr = ["fileName"];
      let flag = false;
      while (keyArr[0] && !flag) {
        if (item[keyArr.shift()].includes(name)) flag = true;
      }
      return flag;
    }
  }
};
</script>
<style lang="scss" scoped>
$header-height: 46px;
.all {
  height: 100%;
  position: relative;
  background-color: #fff;
  display: flex;
  flex-direction: column;
}
.header-top {
  font-size: 16px;
  font-weight: 600;
  color: var(--key-color);
  border-bottom: 1px solid #ebefff;
  padding: var(--small-space) var(--big-space);
  display: flex;
  justify-content: space-between;
  align-items: center;
  span {
    font-size: 16px;
    font-weight: 600;
    line-height: 35px;
    color: var(--key-color);
  }
  .leftBox{
    display: flex;
    align-items: center;
    button{
      margin-left: 10px;
    }
  }
}
.midd {
  padding: var(--middle-space) var(--big-space);
  height: 1px;
  flex-grow: 1;
  .btn {
    cursor: pointer;
    color: var(--theme-color);
    margin-right: 5px;
  }
}
.upload-file{
  /deep/ .el-upload-list {
    display: block !important;
  }
}
</style>
